import Result from "@/core/common/Result";

export type IgnorarPesquisaParams = {
  pesquisaId: string;
};

export interface IIgnorarPesquisaCSATUseCase {
  ignorarPesquisa(params: IgnorarPesquisaParams): Promise<Result<void>>;
}

export const ignorarPesquisaCSATUseCaseDI = "ignorarPesquisaCSATUseCaseDI";
